import React from 'react';
import { Select, MenuItem, FormControl, InputLabel, Chip } from '@material-ui/core';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

const ENVIRONMENTS = [
  { value: 'dev', label: 'Development', color: '#4caf50' },
  { value: 'staging', label: 'Staging', color: '#ff9800' },
  { value: 'uat', label: 'UAT', color: '#2196f3' },
  { value: 'prod', label: 'Production', color: '#f44336' },
];

const EnvironmentPickerComponent = (props: {
  onChange: (value: string) => void;
  rawErrors?: string[];
  required?: boolean;
  formData?: string;
  schema: { title?: string; description?: string };
  uiSchema?: { 'ui:options'?: { environments?: string[] } };
}) => {
  const { onChange, required, formData, schema, uiSchema } = props;
  const allowedEnvs = uiSchema?.['ui:options']?.environments;
  const environments = allowedEnvs
    ? ENVIRONMENTS.filter(e => allowedEnvs.includes(e.value))
    : ENVIRONMENTS;

  return (
    <FormControl fullWidth required={required} margin="normal">
      <InputLabel>{schema.title || 'Environment'}</InputLabel>
      <Select
        value={formData || ''}
        onChange={e => onChange(e.target.value as string)}
      >
        {environments.map(env => (
          <MenuItem key={env.value} value={env.value}>
            <Chip
              size="small"
              label={env.label}
              style={{ backgroundColor: env.color, color: 'white', marginRight: 8 }}
            />
            {env.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export const EnvironmentPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'EnvironmentPicker',
    component: EnvironmentPickerComponent,
  }),
);
